import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';

import { FileDetail } from '@classes/file/file-detail';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-config-files-list',
    templateUrl: './config-files-list.component.html',
    styleUrls: ['./config-files-list.component.scss']
})
export class ConfigFilesListComponent implements OnInit, OnChanges, OnDestroy {
    @Input() title: string;
    @Input() files: FileDetail[];
    @Input() selectedFileId: number;
    @Input() selectedFileIds: number[];
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @Output() selectedFileChanged = new EventEmitter<FileDetail>();

    private loadingSub: Subscription;

    displayedColumns: string[] = ['name', 'source', 'type', 'editedOn', 'uploadedOn', 'uploadedBy', 'select'];
    dataSource: MatTableDataSource<FileDetail>;
    systemName = 'SYSTEM';
    isLoading: boolean;

    constructor(
        private uiSrv: UiService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.initTable();
    }

    isSelected(fileId: number): boolean {
        if(this.selectedFileId) {
            return fileId === this.selectedFileId;
        }

        if(this.selectedFileIds) {
            return this.selectedFileIds.indexOf(fileId) !== -1;
        }

        return false;
    }

    onSelect(file: FileDetail): void {
        this.selectedFileChanged.emit(file);
    }

    private initTable(): void {
        this.dataSource = new MatTableDataSource(this.files);
        this.dataSource.sort = this.sort;
    }

    private initSubscriptions(): void {
        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
